import { render, staticRenderFns } from "./FlexRow.vue?vue&type=template&id=24be6e25&scoped=true"
import script from "./FlexRow.vue?vue&type=script&lang=js"
export * from "./FlexRow.vue?vue&type=script&lang=js"
import style0 from "./FlexRow.vue?vue&type=style&index=0&id=24be6e25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24be6e25",
  null
  
)

export default component.exports